module.exports = __webpack_public_path__ + "static/clickmap3-6f7780c39c3820ae6d8a1128bac67cfb.png";